import React, { useEffect } from 'react';
import RouterView from '@/router';

function App() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      window._AMapSecurityConfig = {
        securityJsCode: '4123a266e8def6b673e79e195ca0e2cb',
      };
    } else {
      window._AMapSecurityConfig = {
        serviceHost: 'https://chanyeos.com/_AMapService',
      };
    }
  }, []);

  return (
    <RouterView />
  );
}

export default App;
